import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

interface IContainer {
    backgroundImgPath: string,
    colorProp: string,
    needCarouselWrap: boolean,
}

export const Container = styled.div<IContainer>`
    width: 100%;
    height: 432px;
    padding-top: 16px;
    background: url(${({ backgroundImgPath }) => backgroundImgPath}) left / cover no-repeat ;
    border-radius: ${BorderRadius.OuterBlockRadius};
    color: ${({ colorProp }) => colorProp};
    ${({ needCarouselWrap }) => needCarouselWrap ? '' : 'gap: 6px'};

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding-right: 10px;
        ${({ needCarouselWrap }) => needCarouselWrap ? '' : 'gap: 4px'};
    }

    @media (max-width: ${breakPoints.mobile}) {
        height: 628px;
        flex-direction: column;
        padding-right: 10px;
        padding-left: 10px;
        justify-content: flex-start;
        gap: 24px;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        margin-left: -8px;
        margin-right: -8px;
        align-items: center;
    }
`;

export const Wrapper = styled.div`
    gap: 24px;

    @media (max-width: ${breakPoints.desktop}) {
        gap: 32px;
    }
`;

export const InfoBlock = styled.div<{ needCarouselWrap: boolean }>`
    width: 51%;
    ${({ needCarouselWrap }) => needCarouselWrap ? 'width: calc(51% + 6px)' : ''};
    height: fit-content;
    padding: 48px 60px 0 128px;
    gap: 7px;

    @media (max-width: ${breakPoints.desktop}) {
        padding: 24px 50px 0 40px;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 45%;
        ${({ needCarouselWrap }) => needCarouselWrap ? 'width: calc(45% + 6px)' : ''};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 65%;
        ${({ needCarouselWrap }) => needCarouselWrap ? 'width: calc(65% + 6px)' : ''};
        padding-right: 90px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: calc(54% + 9px);
        ${({ needCarouselWrap }) => needCarouselWrap ? 'width: calc(55% + 6px)' : ''};
        padding-right: 80px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        max-height: 160px;
        padding: 0 20px 0 14px;

        & + div {
            ${({ needCarouselWrap }) => needCarouselWrap ? '' : 'flex-basis: auto'};
            margin: 0;
        }
    }
`;

export const Title = styled.div`
    ${FONTS.H2};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.H4};
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H3};
    }
`;

export const Text = styled.div`
    min-height: 63px;
    ${FONTS.M};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.S};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.mobile}) {
        min-height: fit-content;
    }
`;

export const CardsBlock = styled.div`
    width: calc(49% - 6px);
    align-items: center;
    padding-right: 85px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: calc(54% - 6px);
        padding-right: 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: calc(35% - 6px);
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: calc(45% - 6px);
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 304px;
    }
`;

export const CardsBlockWrap = styled.div`
    width: 49%;
`;

export const CardsBlockWrap2 = styled.div`
    width: 100%;
`;
